export default "__VITE_ASSET__r40P5a$T__"